import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';

// 布局
import MainLayout from './components/MainLayout';

// 页面
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ContentCenter from './pages/ContentCenter';
import VideoStudio from './pages/VideoStudio';
import AccountManage from './pages/AccountManage';
import PublishManage from './pages/PublishManage';
import DataStats from './pages/DataStats';
import Settings from './pages/Settings';

// 路由守卫
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  return (
    <ConfigProvider locale={zhCN}>
      <BrowserRouter>
        <Routes>
          {/* 公开路由 */}
          <Route path="/login" element={<Login />} />

          {/* 受保护路由 */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="content" element={<ContentCenter />} />
            <Route path="video" element={<VideoStudio />} />
            <Route path="account" element={<AccountManage />} />
            <Route path="publish" element={<PublishManage />} />
            <Route path="stats" element={<DataStats />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
